<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Create New" : "Update" }} Protection</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <ValidationObserver v-slot="{ invalid }">
      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <div class="vx-col text-center w-full">
            <span>Logo</span>
          </div>
          <Upload
            @on-success="success"
            @on-error="error"
            @on-delete="deleteImage"
            limit="1"
            width="95%"
          ></Upload>

          <!-- Attacks -->
          <vs-select
            placeholder="Select"
            class="w-full special-form"
            icon-no-border
            multiple
            icon="icon icon-code"
            icon-pack="feather"
            label="Attacks"
            v-model="dataAttacks"
          >
            <vs-select-item
              :key="index"
              :value="item._id"
              :text="item.name"
              v-for="(item,index) in dataAttackOptions"
            />
          </vs-select>

          <!-- Available Packages -->
          <vs-select
            placeholder="Select"
            class="w-full special-form"
            icon-no-border
            icon="icon icon-package"
            icon-pack="feather"
            label="Available Packages"
            multiple
            v-model="dataPackages"
          >
            <vs-select-item
              :key="index"
              :value="item._id"
              :text="item.title"
              v-for="(item,index) in dataPackageOptions"
            />
          </vs-select>

          <!-- Name -->
          <ValidationProvider
            immediate
            name="name"
            rules="required|min:1|max:100"
            v-slot="{ errors }"
          >
            <vs-input
              name="name"
              icon-no-border
              icon="icon icon-shield"
              icon-pack="feather"
              label="Name"
              placeholder="Ex: Themida"
              v-model="dataName"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Protection name is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Version -->
          <ValidationProvider
            immediate
            name="version"
            rules="required|min:1|max:100"
            v-slot="{ errors }"
          >
            <vs-input
              name="version"
              icon-no-border
              icon="icon icon-activity"
              icon-pack="feather"
              label="Version"
              placeholder="Ex: 3.84"
              v-model="dataVersion"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Protection version is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <vs-alert :active="isError" class="mt-5" color="danger" icon="new_releases">
            <span>{{error_message}}</span>
          </vs-alert>
        </div>
      </component>
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="updateProtection"
          :disabled="invalid"
          v-if="dataId !== ''"
        >Update</vs-button>
        <vs-button class="mr-6" @click="createProtection" :disabled="invalid" v-else>Create</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
      </div>
    </ValidationObserver>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import eventBus from '../../eventBus'
import Upload from '../upload/Upload'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Upload,
    VuePerfectScrollbar
  },
  data () {
    return {
      isError: false,
      image_id: null,
      error_message: '',
      dataId: '',
      dataName: '',
      dataLogo: '',
      dataVersion: '',
      dataAttacks: [],
      dataAttackOptions: [],
      dataPackages: [],
      dataPackageOptions: [],
      dataCreatedAt: '',
      dataUpdatedAt: '',
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      this.loadAttacks()
      this.loadPackages()
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
      } else {
        // Edit comes here
        const {
          _id,
          name,
          logo,
          version,
          attacks,
          packages,
          createdAt,
          updatedAt
        } = JSON.parse(JSON.stringify(this.data))
        this.dataId = _id
        this.dataLogo = logo
        this.dataVersion = version
        this.dataName = name
        this.dataAttacks = []
        attacks.forEach((attack) => {
          this.dataAttacks.push(attack._id)
        })
        this.dataPackages = []
        packages.forEach((p) => {
          this.dataPackages.push(p._id)
        })
        this.dataCreatedAt = createdAt
        this.dataUpdatedAt = updatedAt
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.initValues()
        }
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    loadAttacks () {
      this.$http.get('/management/attacks').then((res) => {
        if (res.data.status === true) {
          this.dataAttackOptions = res.data.attacks
        }
      })
    },
    loadPackages () {
      this.$http.get('/management/packages').then((res) => {
        if (res.data.status === true) {
          this.dataPackageOptions = res.data.packages
        }
      })
    },
    success (data) {
      this.image_id = data.message
    },
    error (data) {
      this.$swal({
        position: 'bottom-start',
        icon: 'error',
        toast: true,
        title: data.data.message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      })
    },
    getImage () {
      return `${process.env.VUE_APP_BASE_URL}/images/${this.image_id}`
    },
    deleteImage (data) {
      if (this.image_id !== null) {
        this.$http
          .delete(`/images/${this.image_id}`)
          .then((res) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'success',
              toast: true,
              title: 'Image successfully deleted.',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            })
          })
          .catch((err) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'error',
              toast: true,
              title: err.response.message,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            })
          })
        this.image_id = null
      }
    },
    initValues () {
      if (this.data.id) return
      this.dataId = ''
      this.dataName = ''
      this.dataVersion = ''
      this.dataLogo = ''
      this.dataAttacks = []
      this.dataCreatedAt = ''
      this.dataUpdatedAt = ''
    },
    isEmpty (val) {
      if (val === null || val === '' || val === undefined) {
        return true
      }
      return false
    },
    checkForm () {
      let errors = false
      if (this.isEmpty(this.dataId) || this.isEmpty(this.dataName)) {
        errors = true
      }
      return errors
    },
    updateProtection () {
      if (!this.checkForm()) {
        const data = {
          _id: this.dataId,
          name: this.dataName,
          version: this.dataVersion,
          packages: this.dataPackages
        }
        if (this.dataAttacks.length > 0) {
          data['attacks'] = this.dataAttacks
        }
        if (this.image_id !== null) {
          data['logo'] = this.image_id
        }
        this.$http
          .put('/management/protections', data)
          .then((res) => {
            eventBus.$emit('refresh-protections')
            if (res.data.status === true) {
              this.$emit('closeSidebar')
              this.initValues()
              this.$swal({
                position: 'bottom-start',
                icon: 'success',
                toast: true,
                title: 'Protection successfully updated.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            } else {
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: 'Error occurred updating the protection.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            }
          })
          .catch((err) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'error',
              toast: true,
              title: 'Error occurred updating the protection.',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            })
          })
      } else {
        this.error_message = 'Please make sure form is correct.'
        this.isError = true
      }
    },
    createProtection () {
      const data = {
        name: this.dataName,
        logo: this.image_id,
        version: this.dataVersion,
        packages: this.dataPackages,
        attacks: this.dataAttacks
      }
      if (this.dataAttacks.length > 0) {
        if (this.image_id !== null) {
          this.$http
            .post('/management/protections', data)
            .then((res) => {
              eventBus.$emit('refresh-protections')
              if (res.data.status === true) {
                this.$emit('closeSidebar')
                this.initValues()
                this.$swal({
                  position: 'bottom-start',
                  icon: 'success',
                  toast: true,
                  title: 'Protection successfully created.',
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true
                })
              } else {
                this.$swal({
                  position: 'bottom-start',
                  icon: 'error',
                  toast: true,
                  title: 'Error occurred creating the protection.',
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true
                })
              }
            })
            .catch((err) => {
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: 'Error occurred creating the protection.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            })
        } else {
          this.isError = true
          this.error_message = 'You must upload a logo for the protection.'
        }
      } else {
        this.isError = true
        this.error_message =
          'You must select at least 1 attack to continue.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.special-form {
  margin-top: 1.5rem;
}
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>